/**
 * General Icon Library
 * Common UI icons for general application use
 * Conservative set with only confirmed available icons from @untitledui/icons
 */

// Import general-purpose icons from Untitled UI
import {
  // Actions & CRUD - confirmed working
  Plus,
  Minus,
  X,
  Check,
  Trash01,
  Copy01,
  Edit02,
  Save01,
  RefreshCw01,
  DotsVertical,
  DotsHorizontal,
  FilterLines,

  // Arrows & Navigation - confirmed working
  ArrowUp,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ChevronUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronSelectorVertical,

  // Navigation & Layout - confirmed working
  HomeLine,
  Rows01,
  Users01,
  CheckDone01,
  MessageChatCircle,
  LayoutAlt01,
  Share04,

  // Communication - confirmed working
  Mail01,
  MessageSquare01,
  Phone,
  Send01,
  Translate02,

  // Media & Content - confirmed working
  PlayCircle,
  PauseCircle,
  Image01,
  Maximize01,
  Minimize01,
  Microphone01,

  // Interface & Controls - confirmed working
  Eye,
  EyeOff,
  Lock01,
  Loading01,
  Zap,
  Star01,
  Heart,
  Share07,
  Link01,
  LinkExternal01,
  Globe01,
  MagicWand01,
  // Building / clinic — used for the Parallel Clinic sidebar entry.
  // Building02 reads as a clinic/office shape with a clean outline that
  // pairs well with the brand glyphs at sidebar sizes.
  Building02,

  // Files & Folders - confirmed working
  Folder,
  File02,
  Download01,
  Upload01,
  UploadCloud02,
  FilePlus02,
  FileCheck02,

  // Data & Analytics - confirmed working
  BarChart01,
  TrendUp01,
  TrendDown01,
  Database01,
  Grid01,
  List,

  // Status & Indicators - confirmed working
  CheckCircle,
  XCircle,
  AlertCircle,
  InfoCircle,
  HelpCircle,
  MinusCircle,
  PlusCircle,

  // Time & Calendar - confirmed working
  Calendar,
  Clock,

  // Tools & Settings - confirmed working
  Settings01,
  Tool01,
  Sliders01,
  Code01,
  Terminal,

  // Security & Access - confirmed working
  Shield01,
  ShieldTick,
  Key01,
  UserCheck01,
  UserX01,
  LogOut01,
} from "@untitledui/icons";

// Export grouped general icons
export const ActionIcons = {
  Plus,
  Minus,
  X,
  Check,
  Trash: Trash01,
  Copy: Copy01,
  Edit: Edit02,
  Save: Save01,
  Refresh: RefreshCw01,
  DotsVertical,
  DotsHorizontal,
  Filter: FilterLines,
  LogOut: LogOut01,
};

export const ArrowIcons = {
  Up: ArrowUp,
  Down: ArrowDown,
  Left: ArrowLeft,
  Right: ArrowRight,
  ChevronUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronSelectorVertical,
};

export const SidebarNavIcons = {
  Home: HomeLine,
  Sessions: Rows01,
  Patients: Users01,
  Templates: CheckDone01,
  Support: MessageChatCircle,
  Widget: LayoutAlt01,
  Share: Share04,
};

export const CommunicationIcons = {
  Mail: Mail01,
  Message: MessageSquare01,
  Phone,
  Send: Send01,
  Translate: Translate02,
};

export const MediaIcons = {
  Play: PlayCircle,
  Pause: PauseCircle,
  Image: Image01,
  Maximize: Maximize01,
  Minimize: Minimize01,
  Microphone: Microphone01,
};

export const InterfaceIcons = {
  Eye,
  EyeOff,
  Lock: Lock01,
  Loading: Loading01,
  Zap,
  Star: Star01,
  Heart,
  Share: Share07,
  Link: Link01,
  LinkExternal: LinkExternal01,
  Globe: Globe01,
  MagicWand: MagicWand01,
  // Building / clinic icon — used for the Parallel Clinic sidebar entry.
  Building: Building02,
};

export const FileIcons = {
  Folder,
  File: File02,
  Download: Download01,
  Upload: Upload01,
  UploadCloud02: UploadCloud02,
  FilePlus: FilePlus02,
  FileCheck: FileCheck02,
};

export const DataIcons = {
  BarChart: BarChart01,
  TrendUp: TrendUp01,
  TrendDown: TrendDown01,
  Database: Database01,
  Grid: Grid01,
  List,
};

export const StatusIndicatorIcons = {
  CheckCircle,
  XCircle,
  AlertCircle,
  InfoCircle,
  HelpCircle,
  MinusCircle,
  PlusCircle,
};

export const TimeIcons = {
  Calendar,
  Clock,
};

export const ToolIcons = {
  Settings: Settings01,
  Tool: Tool01,
  Sliders: Sliders01,
  Code: Code01,
  Terminal,
};

export const SecurityIcons = {
  Shield: Shield01,
  ShieldTick,
  Key: Key01,
  UserCheck: UserCheck01,
  UserX: UserX01,
};

// Export all general icons for easy access
export const GeneralIcons = {
  ...ActionIcons,
  ...ArrowIcons,
  ...SidebarNavIcons,
  ...CommunicationIcons,
  ...MediaIcons,
  ...InterfaceIcons,
  ...FileIcons,
  ...DataIcons,
  ...StatusIndicatorIcons,
  ...TimeIcons,
  ...ToolIcons,
  ...SecurityIcons,
  // Add commonly used aliases for backward compatibility
  User01: Users01,
  File02: File02,
  Globe: Globe01,
  Translate: Translate02,
  MagicWand: MagicWand01,
  ShieldTick: ShieldTick,
};
